import React from 'react'

import { AttractionImage } from 'src/components/attraction-image'
import { Attraction } from 'src/interfaces/Attraction'

const style = require('./AttractionCard.css')

export interface AttractionCardProps {
  attraction: Attraction,
  onClick: () => void,
}

export const AttractionCard = ({
  attraction: { name, imageURL },
  onClick,
}: AttractionCardProps) => (
  <button
    className={style.attractionCardWrapper}
    onClick={onClick}
  >
    <div className={style.attractionCardContainer}>
      <AttractionImage
        src={imageURL}
        name={name}
      />
      <div className={style.attractionCardTitle}>
        {name}
      </div>
    </div>
  </button>
)
